import { render, staticRenderFns } from "./CompaniasNavieras.vue?vue&type=template&id=a46cc7a2"
import script from "./CompaniasNavieras.vue?vue&type=script&lang=js"
export * from "./CompaniasNavieras.vue?vue&type=script&lang=js"
import style0 from "./CompaniasNavieras.vue?vue&type=style&index=0&id=a46cc7a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports